import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import { getServerData } from 'utils/getServerData';
import {
  fetchJSONDataByTitle,
  hideZipMigratedDialog,
} from 'containers/Landing/actions';
import { selectShowZipMigratedDialog } from 'containers/Landing/selectors';
import { Dialog, Button, Img, Span } from 'components/Ui';
import logoPrimoBrands from 'images/logoPrimoBrands.png';
import styles from './styles.scss';

const ZipMigratedDialog = ({ classes, onContinue }) => {
  const [migrationUrl, setMigrationUrl] = useState('/to-ready-refresh');
  const [postalCode, setPostalCode] = useState('');
  const isVisible = useSelector(selectShowZipMigratedDialog());
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    setMigrationUrl(getServerData('MIGRATION_URL'));

    dispatch(
      fetchJSONDataByTitle({
        title: 'Customer Migration Config',
        key: 'cutoffBranches',
      }),
    );
  }, []);

  useEffect(() => {
    setPostalCode(localStorage.getItem('confirmedPostalCode'));
  });

  const onClose = () => {
    dispatch(hideZipMigratedDialog());
    localStorage?.removeItem('confirmedPostalCode');
  };

  return (
    <Dialog
      open={isVisible}
      onClose={onClose}
      classes={classes}
      fullScreen={isMobile}
      isCloseIcon={false}
    >
      <div className={styles.container}>
        <Img
          src={logoPrimoBrands}
          alt="Primo Brands Logo"
          className={styles.logo}
        />
        <p className={styles.text}>
          <Span>Your ZIP code</Span> {postalCode}{' '}
          <Span>
            is confirmed. Shop now for your favorite water selections on
            ReadyRefresh.com.
          </Span>
        </p>
        <Button
          text="Start Shopping"
          onClick={onContinue}
          fullSend
          href={`${migrationUrl}?zipCode=${postalCode}`}
        />
        <br />
        <br />
        <Button
          text="Change Zip Code"
          onClick={onClose}
          link
          className={styles.btnStay}
        />
      </div>
    </Dialog>
  );
};

export default ZipMigratedDialog;
